import { render, staticRenderFns } from "./SidebarInfo.vue?vue&type=template&id=575107ff&scoped=true&"
import script from "./SidebarInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarInfo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInfo.vue?vue&type=style&index=0&id=575107ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575107ff",
  null
  
)

export default component.exports